import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, theme } from 'antd';

const { useToken } = theme;

// Mapa tone → props de Button. Usamos tokens del theme — nada de clases
// Tailwind de color (regla `feedback_use_whitTheme`).
const buttonPropsByTone = (tone, token) => {
  switch (tone) {
    case 'success':
      return {
        type: 'primary',
        style: { background: token.colorSuccess, borderColor: token.colorSuccess },
      };
    case 'warning':
      return {
        type: 'primary',
        style: { background: token.colorWarning, borderColor: token.colorWarning },
      };
    case 'primary':
      return { type: 'primary' };
    default:
      return { type: 'default' };
  }
};

// Tres espacios fijos (principal · icono · menú): mismo ancho y orden en todas las
// filas, así los botones quedan alineados y la fila no cambia de altura.
const PRIMARY_WIDTH = 128;
const ICON_WIDTH = 32;
const SLOT_GAP = 8;
export const ROW_ACTIONS_WIDTH = PRIMARY_WIDTH + ICON_WIDTH * 2 + SLOT_GAP * 2;

/**
 * Columna de acciones estándar de una fila de tabla.
 *
 * @param {object}   [primary]       acción principal: { label, tone, onClick, disabled? }.
 *                                   tone: 'success' | 'warning' | 'primary' | 'default'.
 *                                   Sin `primary` el espacio queda vacío (mantiene la alineación).
 * @param {ReactNode} [icon]         nodo para el espacio del icono (descarga, historial…).
 * @param {object}   [menu]          menú "⋮": { items, onClick } (props de `Dropdown.menu`).
 *                                   Sin ítems no se muestra el botón.
 * @param {boolean}  [menuDisabled]  deshabilita el menú (p. ej. mientras hay una acción en curso).
 */
function RowActions({ primary, icon, menu, menuDisabled = false }) {
  const { token } = useToken();
  const hasMenu = Boolean(menu?.items?.length);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `${PRIMARY_WIDTH}px ${ICON_WIDTH}px ${ICON_WIDTH}px`,
        columnGap: SLOT_GAP,
        alignItems: 'center',
      }}
    >
      {primary ? (
        <Button
          size="small"
          block
          disabled={primary.disabled}
          onClick={primary.onClick}
          {...buttonPropsByTone(primary.tone, token)}
        >
          {primary.label}
        </Button>
      ) : (
        <span aria-hidden="true" />
      )}

      {icon ?? <span aria-hidden="true" />}

      {hasMenu ? (
        <Dropdown trigger={['click']} menu={menu} disabled={menuDisabled}>
          <Button
            size="small"
            icon={<MoreOutlined />}
            aria-label="Más acciones"
            disabled={menuDisabled}
          />
        </Dropdown>
      ) : (
        <span aria-hidden="true" />
      )}
    </div>
  );
}

export default RowActions;
